export default __webpack_public_path__ + "static/media/main-switchboard.b68e36ca.jpg";